"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MatrixDependencies = void 0;

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var MatrixDependencies = {
  createMatrixClass: _factoriesAny.createMatrixClass
};
exports.MatrixDependencies = MatrixDependencies;